/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetBusinessPartnerBukrsRequest = {
  properties: {
    cnpj: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
